<script setup>
import Breadcrumb from '~/components/Breadcrumb'
import BookTitle from '~/components/books/BookTitle'
import BookCover from '~/components/books/BookCover'
import BookSizeInfo from '~/components/books/BookSizeInfo'
import { useBook } from '~/composables/useBook'

const props = defineProps({
  book: {
    type: Object,
    required: true,
  },
  breadcrumb: {
    type: Object,
    required: true,
  },
})

const { genreToKey } = useBook()
const bookClassWithGenre = 'book-basic-info--' + genreToKey(props.book.genres)
</script>

<template>
  <div :class="['book-basic-info container-fluid p-0', bookClassWithGenre]">
    <div class="container pt-32 pt-lg-64 pb-40 position-relative">
      <div class="row">
        <div class="column-info col-md-6 col-lg-7 offset-xl-1">
          <div class="mb-24">
            <Breadcrumb
              v-if="breadcrumb"
              :link="breadcrumb.link"
              :text="breadcrumb.text"
            />
          </div>
          <BookTitle :book="book" />

          <div class="book-cover__wrapper align-self-center">
            <BookCover
              :lazy="false"
              :cover="book.cover"
              :title="book.title"
              :width="310"
              :height="476.55"
              :prize="book.bookPrize"
              rounded
            />
          </div>

          <div class="d-flex flex-wrap flex-gap-16">
            <BookSizeInfo :book="book" />
            <slot name="book-download"></slot>
          </div>

          <p class="mt-24 mb-24">
            {{ book.shortDescription }}
          </p>

          <slot name="book-actions"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@keyframes slideInAndRotate {
  0% {
    opacity: 0;
    transform: rotate(0) translateX(30vw);
  }

  100% {
    opacity: 1;
    transform: rotate(-8deg) translateX(0%);
  }
}

@include generate-genre-classes(
  'background-color',
  'light',
  'book-basic-info',
  1
);

.book__cover {
  width: 210px !important;
  position: relative;
  background-image: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='310' height='476.55'><rect width='310' height='476.55' style='fill:%23fff'%20/></svg>");
}

.book-cover__wrapper {
  z-index: 2;
  margin-bottom: 24px;
}

.column-info {
  display: flex;
  flex-direction: column;
}

@include media-breakpoint-up(md) {
  .book-cover__wrapper {
    position: absolute;
    right: 7%;
    top: 83px;
    margin-bottom: 0;
  }

  .book__cover {
    width: 249.26px !important;
  }

  .column-info {
    position: unset;
    display: block;
  }

  .book-basic-info {
    min-height: 504px;
  }
}

@include media-breakpoint-up(lg) {
  .book-cover__wrapper {
    top: 85px;
    animation: slideInAndRotate 0.4s forwards ease-out;
  }

  .book-basic-info {
    min-height: 537px;
  }

  .book__cover {
    width: fit-content !important;
  }
}
</style>
